// extracted by mini-css-extract-plugin
export var RandomMonsterButton = "monsterprintpage-module--RandomMonsterButton--a8e6a";
export var StatblockImage = "monsterprintpage-module--Statblock-Image--26496";
export var bk = "monsterprintpage-module--bk--c46fe";
export var bodyBlocks = "monsterprintpage-module--body-blocks--343a0";
export var cn = "monsterprintpage-module--cn--712d3";
export var columnWrapper = "monsterprintpage-module--column-wrapper--232bb";
export var f = "monsterprintpage-module--f--71901";
export var fi = "monsterprintpage-module--fi--c1d89";
export var footnoteList = "monsterprintpage-module--footnote-list--cc2b1";
export var footnotes = "monsterprintpage-module--footnotes--5cc12";
export var horizontalMonsterLinks = "monsterprintpage-module--horizontal-monster-links--5aebc";
export var hr1 = "monsterprintpage-module--hr1--5a5ce";
export var interweave = "monsterprintpage-module--interweave--fdfb3";
export var ip = "monsterprintpage-module--ip--861c6";
export var lastModified = "monsterprintpage-module--last-modified--e97e0";
export var loading = "monsterprintpage-module--loading--869d0";
export var monsterBody = "monsterprintpage-module--monster-body--ace7c";
export var monsterImage = "monsterprintpage-module--monster-image--7c6c2";
export var monsterImgFrame = "monsterprintpage-module--monster-img-frame--b00e6";
export var monsterNav = "monsterprintpage-module--monster-nav--6d507";
export var monsterNavLink = "monsterprintpage-module--monster-nav-link--227c2";
export var monsterNavLinks = "monsterprintpage-module--monster-nav-links--4617d";
export var ni = "monsterprintpage-module--ni--65d6a";
export var pageRandomMonsterButton = "monsterprintpage-module--page-random-monster-button--e66d8";
export var psionicTableData = "monsterprintpage-module--psionic-table-data--d8003";
export var psionicsSummary = "monsterprintpage-module--psionics-summary--85ee7";
export var psionicsTable = "monsterprintpage-module--psionics-table--87a00";
export var settingImage = "monsterprintpage-module--setting-image--c814e";
export var source = "monsterprintpage-module--source--aabac";
export var sourceList = "monsterprintpage-module--source-list--29f20";
export var statblock = "monsterprintpage-module--statblock--f290c";
export var topHeader = "monsterprintpage-module--top-header--4cda8";
export var topHeaderInner = "monsterprintpage-module--top-header-inner--5c887";
export var tsr = "monsterprintpage-module--tsr--45b11";
export var tsrFooter = "monsterprintpage-module--tsr-footer--8265f";
export var tsrLabel = "monsterprintpage-module--tsr-label--48ea6";
export var tsrPrint = "monsterprintpage-module--tsr-print--72d02";